import { OAUTH_PROVIDERS, type OAuthProvider } from '@/shared/config/routes';
import type { OAuthMessage, OAuthStatus, SignInView } from '../types';

const STATUSES: readonly OAuthStatus[] = ['ok', 'cancelled', 'error'];

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

/** Accepts only the callback page's message shape; everything else on the channel is ignored. */
export function parseOAuthMessage(data: unknown): OAuthMessage | null {
  if (!isRecord(data) || data.source !== 'macswarm-oauth') return null;
  const status = STATUSES.find((value) => value === data.status);
  if (!status) return null;
  return { source: 'macswarm-oauth', status, isNewAccount: data.isNewAccount === true };
}

export const isOAuthProvider = (value: string | null): value is OAuthProvider =>
  OAUTH_PROVIDERS.some((provider) => provider === value);

/** After a redirect sign-in that failed, the server sends people to /sign-in?oauth=…&status=… */
export function initialSignInView(params: URLSearchParams): SignInView {
  const provider = params.get('oauth');
  const status = params.get('status');
  if (isOAuthProvider(provider) && (status === 'cancelled' || status === 'error')) {
    return { name: 'oauth-error', provider };
  }
  return { name: 'form' };
}
